export enum VatType {
  All = 'All',
  Local = 'LOCAL',
  Export = 'Export',
  SisterCompany = 'SISTER_COMPANY'
}
